<div
  id="modal"
  *ngIf="isVisible"
  class="modal fixed inset-0 right-0 bg-opacity-50 flex justify-end z-50 transition-all ease-in-out"
  [ngClass]="animationClass"
  [style.visibility]="isOpen ? 'visible' : 'hidden'"
  (click)="handleBackgroundClick()"
>
  <div
    class="bg-white shadow-2xl rounded-lg w-[35%] h-auto flex flex-col pt-6 px-6 pb-3 space-y-3 border-l-2 border-lightGray"
    (click)="$event.stopPropagation()"
  >
    <div *ngIf="infoDay && quadrantInfo" class="space-y-4">
      <div class="flex justify-between">
        <h4 class="text-xl font-semibold text-gray-800">Información del día</h4>
        <div class="flex gap-x-4">
          
          <button
            (click)="handleBackgroundClick()"
            class="flex items-center px-5 text-base text-white bg-blue-600 rounded-full hover:bg-blue-700 transition duration-300"
            title="Cerrar"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-5 w-5"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
            Cerrar
          </button>
        </div>
      </div>
      <div class ="flex justify-between items-center mb-4">
        <h4 class="text-xl font-semibold text-gray-800 ">
          {{ infoDay | date : "dd-MM-yyyy" }}
        </h4>
        <button
            (click)="goToCalendarWithFilters()"
            class="flex items-center px-5 py-0.5 text-base text-white bg-green rounded-full hover:bg-darkGreen transition duration-300"
            title="Ver información completa"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-5 w-5 mr-1"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M3 10h18M3 14h18M4 6h16a1 1 0 011 1v10a1 1 0 01-1 1H4a1 1 0 01-1-1V7a1 1 0 011-1z"
              />
            </svg>
            Ver detalles
          </button>
        </div>
      <div class="flex justify-between text-sm">
        <div class="flex gap-4 items-center">
          <span class="w-4 h-4 bg-lightGray rounded-full"></span>
          <p class="text-gray-600">
            <span class="text-lightGray">
              {{ getDayInfo(infoDay)?.total_capacity ?? 0 }}
            </span>
            Ofertadas
          </p>
        </div>

        <div class="flex gap-4 items-center">
          <span class="w-4 h-4 bg-primary rounded-full"></span>
          <p class="text-gray-600">
            <span class="text-primary">
              {{ getDayInfo(infoDay)?.booked?.total ?? 0 }}
            </span>
            Reservadas
          </p>
        </div>

        <div class="flex gap-4 items-center">
          <span class="w-4 h-4 bg-green rounded-full"></span>
          <p class="text-gray-600">
            <span class="text-green">
              {{ getDayInfo(infoDay)?.available ?? 0 }}
            </span>
            Libres
          </p>
        </div>
      </div>

      <div class="flex text-gray-800">
        <ul class="flex justify-evenly w-full gap-2 mb-4">
          <li
            *ngFor="let item of getDayInfo(infoDay)?.booked | keyvalue"
            class="flex justify-center"
          >
            <button
              appFrontBack
              class="px-6 py-1 rounded-full border-lightGray uppercase text-sm"
              (click)="onFilterByVehicleType(item)"
            >
              {{ item.key }}: {{ item.value }}
            </button>
          </li>
        </ul>
      </div>

      <app-generic-table
        [filters]="filters"
        *ngIf="reservations"
        [loading]="loading"
        [tableHeaders]="tableHeaders"
        [items]="reservations"
        [sortColumns]="sorts"
        (changeSorts)="onChangeSorts($event)"
      ></app-generic-table>
    </div>
  </div>
</div>
